import CenaDispositivos from './CenaDispositivos';
export default function AuthHeroPanel() {
  /* SVG e nao PNG: os rotulos das bolhas (os produtos da familia GPS) estao como
     TEXTO dentro do arquivo, entao dao para corrigir. No `foguete123.png` que estava
     aqui eles vinham gravados no bitmap - a foto mostrava GPSf, GPSv, GPSd, nomes
     que nao existem, e nao havia como arrumar sem reabrir a arte.

     De brinde: o SVG tem 11 kB contra os ~300 kB do PNG, e escala sem serrilhar
     na tela grande, onde a ilustracao ocupa metade da largura.

     MOVIMENTO (20/08/2026): as estrelas derivam em duas camadas e os textos deste
     painel assentam em sequencia. O FOGUETE FICA PARADO - flutuacao e escapamento
     pulsando foram avaliados na tela de escolha e recusados. Nao reintroduzir sem
     pedido: a arte parada foi decisao, nao esquecimento.

     REDESENHADO EM 19/08/2026 a pedido ("maior, 2D e com mais detalhes"): dois
     boosters laterais, cone com costura de painel e antena, anel rebitado, faixa
     de identificacao com marcacao diagonal, tubeira com nervuras e reflexo de
     vidro nas escotilhas. Tudo em preenchimento solido com sombra em bloco - o
     desenho continua chapado, sem degrade suave fingindo volume. */
  const BENEFITS = [
    {
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.35C16.5 21.15 20 16.25 20 11V5L12 2z"
            fill="currentColor"
            opacity="0.22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: 'Segurança Corporativa',
      desc: 'Políticas MDM com criptografia e conformidade corporativa',
    },
    {
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Cloud Ready',
      desc: 'Gerencie dispositivos MDM em escala com alta disponibilidade',
    },
    {
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M9 7h6M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      title: 'Device Management',
      desc: 'MDM completo com controle total de cada dispositivo',
    },
    {
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M9 17H7A5 5 0 017 7h2M15 7h2a5 5 0 010 10h-2M8 12h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
      title: 'Compliance & Monitoring',
      desc: 'Compliance MDM automatizado com alertas em tempo real',
    },
  ];

  /* ESTRELAS EM DUAS CAMADAS, para o paralaxe (escolhido em 20/08/2026).

     Antes era UMA camada de 88 estrelas, parada. Paralaxe precisa de dois planos
     movendo em velocidades diferentes - com um plano so, mover tudo junto nao da
     profundidade, da a impressao de que a tela inteira escorregou.

     A divisao e por tamanho, nao aleatoria: as maiores ficam no plano da frente
     (mais rapido) e as menores no fundo (mais lento). E assim que o olho ja
     interpreta distancia - perto e grande e passa rapido.

     O deslocamento e de 24px em 40s e 70s. Numeros baixos de proposito: nao ha o
     que "seguir" com o olho, e o efeito e percebido como ambiente, nao como
     animacao rodando. */
  const estrelas = Array.from({ length: 88 }, (_, i) => ({
    x: (i * 131.3) % 100,
    y: (i * 83.7) % 100,
    r: i % 8 === 0 ? 1.4 : i % 3 === 0 ? 1 : 0.55,
    op: 0.16 + (i % 7) * 0.08,
  }));
  const frente = estrelas.filter((e) => e.r >= 1);
  const fundo = estrelas.filter((e) => e.r < 1);

  return (
    <div
      style={{
        flex: 1,
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        justifyContent: 'center',
        gap: 8,
        padding: '36px 4%',
        background:
          'radial-gradient(circle at 38% 52%, rgba(36,128,255,0.2) 0%, transparent 25%), linear-gradient(135deg, #071228 0%, #0A1F45 36%, #133F83 68%, #0B2148 100%)',
      }}
    >
      {/* `animate-deriva-lenta` / `-lentissima`: keyframes declarados no
          tailwind.config, e desligados por `prefers-reduced-motion` na regra
          global de theme/global.css. */}
      <svg
        className="animate-deriva-lenta"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0 }}
        aria-hidden
      >
        {frente.map((e, i) => (
          <circle key={i} cx={`${e.x}%`} cy={`${e.y}%`} r={e.r} fill="white" opacity={e.op} />
        ))}
      </svg>
      <svg
        className="animate-deriva-lentissima"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0 }}
        aria-hidden
      >
        {fundo.map((e, i) => (
          <circle key={i} cx={`${e.x}%`} cy={`${e.y}%`} r={e.r} fill="white" opacity={e.op} />
        ))}
      </svg>

{/* AS ESFERAS E AS ORBITAS SAIRAM (10/09/2026, a pedido).

         Eram dois "planetas" com halo nos cantos e cinco elipses de orbita
         atravessando o painel. Faziam sentido enquanto a arte era um FOGUETE -
         compunham o espaco em volta dele. Com a cena de dispositivos no lugar,
         viraram enfeite sem assunto: nada num sistema de gerenciamento de
         aparelhos e explicado por planeta.

         Junto sairam os brilhos e os pontinhos ancorados em 23%, 42% e 35% da
         largura: todos foram compostos em volta do FOGUETE, que ficava naquela
         posicao. Com a cena dentro da propria coluna, viraram manchas soltas - a
         nuvem branca no meio do painel era um deles.

         O ceu de estrelas ficou: ele nao afirma nada, so da profundidade ao fundo
         escuro. */}



      {/* O RASTRO SAIU (10/09/2026). Eram tres cones em conic-gradient subindo
          do rodape, ancorados em 23% da largura: a propulsao do FOGUETE. Sem ele,
          viraram um facho de luz atravessando o painel sem explicacao - e a
          mancha clara que aparecia no meio da tela. */}


      {/* COLUNA DA CENA: 42%, mas com um TETO de 520px.

          Antes era 44% sem teto. Em tela larga isso dava uma cena enorme e
          espremia a coluna de texto contra a borda direita - os titulos dos
          cartoes quebravam em duas linhas ("Compliance & / Monitoring") e o rodape
          virava tres. Com teto, a cena para de crescer e a largura que sobra vai
          para o texto, que e quem precisa dela. */}
      <div
        style={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '42%',
          maxWidth: 520,
          flexShrink: 0,
        }}
      >
        {/* Glow radial atrás do foguete */}
        <div
          style={{
            position: 'absolute',
            inset: '5% 10% 12%',
            borderRadius: '50%',
            background: 'radial-gradient(ellipse at 50% 44%, rgba(180,235,255,0.32) 0%, rgba(80,170,255,0.14) 42%, transparent 72%)',
            filter: 'blur(22px)',
            zIndex: 0,
          }}
        />
        <CenaDispositivos />
      </div>

      {/* COLUNA DO TEXTO. `minWidth: 0` porque item de flex nao encolhe abaixo do
          conteudo sem ele - e era isso que empurrava a coluna contra a borda.
          `maxWidth` para a linha de leitura nao virar uma faixa larga demais em
          monitor grande. */}
      <div style={{ flex: 1, minWidth: 0, maxWidth: 620, zIndex: 3, paddingLeft: 40, paddingRight: 16 }}>
        <h2
          className="animate-subir"
          style={{ margin: '0 0 28px', fontSize: 31, fontWeight: 800, color: '#F8FAFC', lineHeight: 1.25, letterSpacing: '-0.5px' }}
        >
          Sua central de
          <br />
          gerenciamento de
          <br />
          dispositivos corporativos
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {BENEFITS.map((b, i) => (
            <div
              key={i}
              className="animate-subir"
              /* Atraso crescente: os quatro cartoes assentam em sequencia, 80ms de
                 intervalo, DEPOIS do formulario (que comeca em 0). O escalonamento
                 e o que faz a tela parecer montada em ordem em vez de aparecer de
                 uma vez - e 80ms e o intervalo em que ainda se percebe a ordem sem
                 a espera incomodar. */
              style={{
                animationDelay: `${0.3 + i * 0.08}s`,
                background: 'rgba(15,35,80,0.56)',
                borderRadius: 16,
                padding: '14px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                backdropFilter: 'blur(16px)',
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 12,
                  flexShrink: 0,
                  background: 'linear-gradient(180deg, rgba(31,80,190,0.5) 0%, rgba(17,54,128,0.28) 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#CFE5FF',
                }}
              >
                {b.icon}
              </div>
              <div>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: '#F8FAFC' }}>{b.title}</div>
                <div style={{ fontSize: 12, color: 'rgba(203,213,225,0.72)', lineHeight: 1.5, marginTop: 2 }}>{b.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 18, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <div
            className="animate-subir"
            style={{
              animationDelay: '0.62s',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              background: 'rgba(66,122,255,0.12)',
              borderRadius: 999,
              padding: '6px 14px',
            }}
          >
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ADE80', boxShadow: '0 0 7px rgba(74,222,128,0.9)' }} />
            <span style={{ fontSize: 11.5, color: 'rgba(219,234,254,0.82)', fontWeight: 500 }}>Sistema operacional · Todos os serviços ativos</span>
          </div>

          {/* SELO ANDROID ENTERPRISE (escolhido em 20/08/2026).

              Diz o que o produto E para quem chega sem saber - a tela de entrada e
              o unico lugar do sistema visto por quem ainda nao usa o sistema. E
              nao e enfeite: este GPShub gerencia aparelhos pela Android Management
              API do Google, com uma enterprise unica, entao o selo descreve a
              tecnologia de verdade por tras da tela.

              Sem logotipo do Google de proposito: reproduzir marca de terceiro
              exige seguir as regras de uso da marca, e nao vou apostar nisso numa
              tela de login. Texto simples resolve. */}
          <div
            className="animate-subir"
            style={{
              animationDelay: '0.68s',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              background: 'rgba(15,35,80,0.5)',
              borderRadius: 999,
              padding: '6px 14px',
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden style={{ color: '#9EC5FF' }}>
              <rect x="5" y="2.5" width="14" height="19" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
              <path d="M10 5.5h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
              <path d="M9.5 12.5l1.8 1.8 3.4-3.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: 11.5, color: 'rgba(219,234,254,0.82)', fontWeight: 500 }}>
              Android Enterprise · Google EMM
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
